import { PromptInputSubmit } from "@/components/ai-elements/prompt-input";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import type { ChatStatus } from "ai";

type PromptSubmitButtonProps = {
  status: ChatStatus | undefined;
  disabled: boolean;
  showEmptyTooltip: boolean;
  isGenerating: boolean;
};

export function PromptSubmitButton({
  status,
  disabled,
  showEmptyTooltip,
  isGenerating,
}: PromptSubmitButtonProps) {
  const button = (
    <PromptInputSubmit
      variant={isGenerating ? "ghost" : "default"}
      status={status}
      className={cn("size-8", "disabled:cursor-not-allowed")}
      disabled={disabled || isGenerating}
    />
  );

  if (!showEmptyTooltip) {
    return button;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-not-allowed pointer-events-auto">
          {button}
        </span>
      </TooltipTrigger>
      <TooltipContent sideOffset={4}>Message is empty</TooltipContent>
    </Tooltip>
  );
}
